var _ = require('underscore');
var Backbone = require('backbone');

const EVENTS = {
	SELECT_SUBTITLE: 'SELECT_SUBTITLE',
	SCROLL_TO: 'SCROLL_TO',

	EDIT_SUBTITLE: 'EDIT_SUBTITLE',
	ADD_SUBTITLE: 'ADD_SUBTITLE',
	DELETE_SUBTITLE: 'DELETE_SUBTITLE',
	SPLIT_SUBTITLE: 'SPLIT_SUBTITLE',
	MERGE_SUBTITLE: 'MERGE_SUBTITLE',
	UNDO_CHANGES: 'UNDO_CHANGES',
	REDO_CHANGES: 'REDO_CHANGES',

	ITALIC: 'ITALIC',
	SEARCH: 'SEARCH',
	NAVIGATE_CHANGE: 'NAVIGATE_CHANGE',
	JUMP_TO: 'JUMP_TO',

	ENABLE_CONTROLS: 'ENABLE_CONTROLS',
	DISABLE_CONTROLS: 'DISABLE_CONTROLS',
	ENABLE_KEYBOARD_CONTROLS: 'ENABLE_KEYBOARD_CONTROLS',
	DISABLE_KEYBOARD_CONTROLS: 'DISABLE_KEYBOARD_CONTROLS',

	SYNC: 'SYNC',
	BLACK_BG: 'BLACK_BG',

	PLAY_SUBTITLE: 'PLAY_SUBTITLE',
	PLAY_SECTION: 'PLAY_SECTION',

	PLAY_VIDEO: 'PLAY_VIDEO',
	JUMP_TO_FRAME: 'JUMP_TO_FRAME',
	PAUSE_VIDEO: 'PAUSE_VIDEO',
	SKIP_FORWARD_1: 'SKIP_FORWARD_1',
	SKIP_BACKWARD_1: 'SKIP_BACKWARD_1',
	VOLUME_UP: 'VOLUME_UP',
	VOLUME_DOWN: 'VOLUME_DOWN',

	UPDATE_SUB_DISPLAY: 'UPDATE_SUB_DISPLAY',
	UPDATE_SUB: 'UPDATE_SUB',
	UPDATE_COUNT: 'UPDATE_COUNT',
	UPDATE_DURATION: 'UPDATE_DURATION',

	BUILD_SETTINGS_CSS: 'BUILD_SETTINGS_CSS',
	RESET_SETTINGS_CSS: 'RESET_SETTINGS_CSS',

	DB_DELETE_SUBTITLE: 'DB_DELETE_SUBTITLE',
	DB_DELETE_PERMANENT_SUBTITLE: 'DB_DELETE_PERMANENT_SUBTITLE',
	DB_UPDATE_SUBTITLE: 'DB_UPDATE_SUBTITLE',
	DB_INSERT_SUBTITLE: 'DB_INSERT_SUBTITLE',
	DB_RESET_SUBTITLE: 'DB_RESET_SUBTITLE',

	DB_UPDATE_SUBTITLE_SUCCESS: 'DB_UPDATE_SUBTITLE_SUCCESS',
	DB_UPDATE_SUBTITLE_FAILURE: 'DB_UPDATE_SUBTITLE_FAILURE',
	DB_INSERT_SUBTITLE_SUCCESS: 'DB_INSERT_SUBTITLE_SUCCESS',
	DB_INSERT_SUBTITLE_FAILURE: 'DB_INSERT_SUBTITLE_FAILURE',
	DB_RESET_SUBTITLE_SUCCESS: 'DB_RESET_SUBTITLE_SUCCESS',
	DB_RESET_SUBTITLE_FAILURE: 'DB_RESET_SUBTITLE_FAILURE',
	DB_DELETE_SUBTITLE_SUCCESS: 'DB_DELETE_SUBTITLE_SUCCESS',
	DB_DELETE_SUBTITLE_FAILURE: 'DB_DELETE_SUBTITLE_FAILURE',
	DB_DELETE_PERMANENT_SUBTITLE_SUCCESS: 'DB_DELETE_PERMANENT_SUBTITLE_SUCCESS',
	DB_DELETE_PERMANENT_SUBTITLE_FAILURE: 'DB_DELETE_PERMANENT_SUBTITLE_FAILURE',

	CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
	UPDATE_LAST_SYNC_TIME: 'UPDATE_LAST_SYNC_TIME',
	DESTROY_ITEMS: 'DESTROY_ITEMS',

	PULL_IN_VIEWPORT: 'PULL_IN_VIEWPORT',

	SCROLL_UP: 'SCROLL_UP',
	SCROLL_DOWN: 'SCROLL_DOWN',
	
	REQUEST_CAPTION_UPDATE: 'REQUEST_CAPTION_UPDATE', //coming from captions waves
	CAPTION_TIMECODES_PREVIEW: 'CAPTION_TIMECODES_PREVIEW', //live preview of timecode changes from editor
	NEW_PLAY_TIME: 'NEW_PLAY_TIME',
	REQUEST_PLAY_TIME_CHANGE: 'REQUEST_PLAY_TIME_CHANGE',
	APP_MODEL_INITIALIZED: 'APP_MODEL_INITIALIZED'
};

class BackboneEvents {
	constructor() {
		_.extend(this, Backbone.Events);
		this.events = EVENTS;
	}
}

//This functions was created in order to return a promise to trigger caller .
//This promise will be resolved only when all the listeners finished their job
class PromiseEventsEmitter extends BackboneEvents {
	constructor() {
		super();
		this.eventCallbacksToPromiseResultsMapper = {}
	}

	subscribe(eventName, callback) {
		let callbackWrapper = this._wrapCallback(callback, eventName); 
		this.listenTo(this, eventName, callbackWrapper);
	}

	emit(eventName) {
		let listenerArgs = Array.prototype.slice.call(arguments, 1);
		this.trigger(eventName, ...listenerArgs);

		return new Promise((resolve, reject) => {
			setTimeout(() => {//Make sure this.trigger will call all listeners
				let listenersResultPromises = this.eventCallbacksToPromiseResultsMapper[eventName];
				if (listenersResultPromises == null) {
					return resolve(null);
				}

				Promise.all(listenersResultPromises)
					.then(() => {
						resolve();
						delete this.eventCallbacksToPromiseResultsMapper[eventName];
					})
					.catch((err) => {
						reject(err);
						delete this.eventCallbacksToPromiseResultsMapper[eventName];
					});
			})
		})
	}

	_wrapCallback(callback, eventName) {
		callback = callback.bind(callback);
		
		return function() { //Do not change to lambda expression - I need to context arguments
			var promiseOrResult = null;

			try {
				promiseOrResult = callback.apply(null, arguments);
				let isReturnPromise = promiseOrResult && promiseOrResult.then != null;
				if (!isReturnPromise) {
					promiseOrResult = Promise.resolve(promiseOrResult)
				}
			} catch(err) {
				promiseOrResult = Promise.reject(err);
			}

			let isEventsCallbackListInitialized = this.eventCallbacksToPromiseResultsMapper[eventName] != null;
			if (!isEventsCallbackListInitialized) {
				this.eventCallbacksToPromiseResultsMapper[eventName] = [];
			}

			this.eventCallbacksToPromiseResultsMapper[eventName].push(promiseOrResult);
		}.bind(this);
	}
}


module.exports = new PromiseEventsEmitter();


// WEBPACK FOOTER //
// ./app/dispatcher.js